<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path d="M10 0.5C15.5228 0.5 20 4.97715 20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5ZM10 2C5.30558 2 1.5 5.80558 1.5 10.5C1.5 15.1944 5.30558 19 10 19C14.6944 19 18.5 15.1944 18.5 10.5C18.5 5.80558 14.6944 2 10 2ZM8.75 11.9393L13.2197 7.46967C13.5126 7.17678 13.9874 7.17678 14.2803 7.46967C14.5466 7.73594 14.5708 8.1526 14.3529 8.44621L14.2803 8.53033L9.28033 13.5303C9.01406 13.7966 8.5974 13.8208 8.30379 13.6029L8.21967 13.5303L5.71967 11.0303C5.42678 10.7374 5.42678 10.2626 5.71967 9.96967C5.98594 9.7034 6.4026 9.6792 6.69621 9.89705L6.78033 9.96967L8.75 11.9393L13.2197 7.46967L8.75 11.9393Z" />
  </svg>
</template>
